import React, { Component } from "react";
import '../css/loadingScreen.css';

class LoadingScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }
    render() {
        return (
            <div id="LoadingScreen">
                Loading...
            </div>
        );
    }
}


export default LoadingScreen;
